import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { PageHeader } from '../../organisms/PageHeader';
import { OutreachNavigation, OutreachNavigationPage, INaviagtions, mapNavigationsToProps } from '../../organisms/outreach/OutreachNavigation';
import { IReportData } from "../../../entities/reports/IReportData";
import {IData as OutreachListData} from "../../../store/outreach/outreachList";
import { FetchState } from '../../../entities/FetchState';
import { OutreachList as OutreachListOrganism } from '../../organisms/outreach/OutreachList';
import { Medewerker } from '../../../entities/Medewerker';

// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
); 

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    list: IReportData<OutreachListData>;
    selectedMedewerker: Medewerker;
}
const mapStateProps = (state: IApplicationState): IStateProps => ({
    list: state.outreach.outreachList.OutreachList,
    selectedMedewerker: state.selectie.selectedMedewerker
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    naviagations: INaviagtions;
    onLoadList: (medewerkerId) => void;
    onClickDetails: (id: string) => void,
    onClickEdit: (id: string) => void,
}
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    naviagations: mapNavigationsToProps(dispatch),
    onLoadList: (medewerkerId) => dispatch(RootActionCreators.Outreach.outreachList.FetchData(medewerkerId)),
    onClickDetails: (id: string) => dispatch(RootActionCreators.Navigate.ToOutreachDetail(id)),
    onClickEdit: (id: string) => dispatch(RootActionCreators.Navigate.ToOutreachEdit(id)),
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const OutreachList = (props: AllProps) => {
    const classes = useStyles(useTheme());

    const refresh = () => {
        props.onLoadList(props.selectedMedewerker?.id ?? "");
    }
    
    // Load the list when the component mounts or when the list state is NotFetched
    React.useEffect(() => {
        refresh();
    }, []);

    return <OutreachNavigation selected={OutreachNavigationPage.List} navigations={props.naviagations}>
            
        <PageHeader
            title="Outreach"
            subTitle="Lijst van outreach activiteiten"
            explainText="Hieronder vind je een lijst van alle outreach activiteiten die zijn uitgevoerd door de organisatie. Je kan de lijst filteren op medewerker, en sorteren op medewerkers, datum contacten, organisatie en doelgroepen. Dit helpt je om snel de informatie te vinden die je nodig hebt."
        />

        <OutreachListOrganism
            data={props.list.data}
            loading={props.list.state !== FetchState.Success && props.list.state !== FetchState.Error}
            hasError={props.list.state === FetchState.Error}
            errorDetails={props.list.errorMessage}
            onClickDetails={props.onClickDetails}
            onClickEdit={props.onClickEdit}
            onRefresh={refresh}
            selectedMedewerker={props.selectedMedewerker}
            syncMedewerkerWithRedux={true}
            onChangeMedewerker={(medewerker) => {
                props.onLoadList(medewerker?.id ?? "");
            }}
            title="Outreach Lijst"
        />

        </OutreachNavigation>;
};

export default connect(mapStateProps, mapDispatchProps)(OutreachList);